<template>
  <dialog id="download_modal" class="modal">
    <div class="modal-box">
      <h3 class="mb-2 text-lg font-bold">Đang tải tệp tin . . .</h3>
      <Loading />
      <div class="modal-action">
        <form method="dialog" class="flex gap-2">
          <button
            class="btn btn-outline"
            @click="file_download.cancel_download"
          >
            Hủy bỏ
          </button>
        </form>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import Loading from "@/components/LoadingTemplate.vue";
import { use_file_download } from "./useFileDownload";
const file_download = use_file_download();
</script>
